import { SxProps, Theme } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'

export interface TyreIconProps {
  fontSize?: 'small' | 'medium' | 'large'
  sx?: SxProps<Theme>
}

export const TyreIcon: React.FC<TyreIconProps> = ({ fontSize, sx }) => {
  return (
    <SvgIcon fontSize={fontSize} sx={sx}>
      <TyreSVG />
    </SvgIcon>
  )
}

export const TyreSVG = () => {
  return (
    <svg data-testid='tyre-svg-icon' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='12' cy='12' r='10' stroke='CurrentColor' strokeWidth='4' />
      <circle cx='12' cy='12' r='6.61864' stroke='CurrentColor' />
      <circle cx='12' cy='12' r='3.05085' stroke='CurrentColor' />
      <line x1='16.8536' y1='7.35355' x2='14.5525' y2='9.65465' stroke='CurrentColor' />
      <line x1='16.8536' y1='7.35355' x2='14.5525' y2='9.65465' stroke='CurrentColor' />
      <line x1='9.85355' y1='14.3536' x2='7.55246' y2='16.6546' stroke='CurrentColor' />
      <line x1='9.85355' y1='14.3536' x2='7.55246' y2='16.6546' stroke='CurrentColor' />
      <line x1='7.35355' y1='7.14645' x2='9.65465' y2='9.44754' stroke='CurrentColor' />
      <line x1='7.35355' y1='7.14645' x2='9.65465' y2='9.44754' stroke='CurrentColor' />
      <line x1='14.3536' y1='14.1464' x2='16.6546' y2='16.4475' stroke='CurrentColor' />
      <line x1='14.3536' y1='14.1464' x2='16.6546' y2='16.4475' stroke='CurrentColor' />
      <line x1='5.5' y1='12.05' x2='8.75424' y2='12.05' stroke='CurrentColor' />
      <line x1='5.5' y1='12.05' x2='8.75424' y2='12.05' stroke='CurrentColor' />
      <line x1='14.9492' y1='12.05' x2='18.2034' y2='12.05' stroke='CurrentColor' />
      <line x1='14.9492' y1='12.05' x2='18.2034' y2='12.05' stroke='CurrentColor' />
      <line x1='12' y1='5.6949' x2='12' y2='8.94914' stroke='CurrentColor' />
      <line x1='12' y1='5.6949' x2='12' y2='8.94914' stroke='CurrentColor' />
      <line x1='12' y1='15' x2='12' y2='18.2542' stroke='CurrentColor' />
      <line x1='12' y1='15' x2='12' y2='18.2542' stroke='CurrentColor' />
    </svg>
  )
}
